// ฟังก์ชันสำหรับแมพสัญลักษณ์หุ้นกับอีโมจิ
export function getStockEmoji(symbol: string): string {
  const map: Record<string, string> = {
    // Tech Giants
    AAPL: '🍎',      // Apple
    MSFT: '🪟',      // Microsoft
    GOOG: '🔍',      // Google
    GOOGL: '🔍',     // Google (Class A)
    AMZN: '📦',      // Amazon
    TSLA: '🚗',      // Tesla
    META: '📘',      // Meta (Facebook)
    NFLX: '🎬',      // Netflix
    NVDA: '🤖',      // Nvidia
    INTC: '💾',      // Intel
    AMD: '🔋',       // AMD
    IBM: '💻',       // IBM
    ORCL: '🗄️',     // Oracle
    CRM: '☁️',      // Salesforce
    CSCO: '🌐',     // Cisco
    QCOM: '📡',     // Qualcomm
    ADBE: '🖌️',     // Adobe
    TXN: '🔌',      // Texas Instruments
    AVGO: '📶',     // Broadcom
    NOW: '🕒',      // ServiceNow
    SHOP: '🛍️',    // Shopify
    SNOW: '❄️',     // Snowflake
    ZM: '🎥',       // Zoom
    DOCU: '📝',     // DocuSign
    // Space/Aerospace
    SPCE: '🛰️',     // Virgin Galactic
    RKLB: '🚀',     // Rocket Lab
    MAXR: '🛰️',     // Maxar Technologies
    LMT: '🛡️',     // Lockheed Martin
    NOC: '🛡️',     // Northrop Grumman
    BA: '✈️',       // Boeing
    GD: '🛡️',      // General Dynamics
    RTX: '🛡️',     // RTX (Raytheon)
    AJRD: '🚀',     // Aerojet Rocketdyne
    SPIR: '🛰️',    // Spire Global
    ASTS: '📡',     // AST SpaceMobile
    // Financials
    JPM: '🏦', BAC: '🏦', WFC: '🏦', C: '🏦', GS: '💰', MS: '💰', AXP: '💳', V: '💳', MA: '💳',
    // Consumer
    DIS: '🏰', WMT: '🛒', TGT: '🎯', HD: '🏠', LOW: '🛠️', MCD: '🍔', SBUX: '☕', KO: '🥤', PEP: '🥤', COST: '🛍️', NKE: '👟', PG: '🧼',
    // Healthcare
    UNH: '🏥', PFE: '💊', JNJ: '💉', MRK: '💊', ABBV: '💉', TMO: '🧪', ABT: '🩺', CVS: '🏪', BMY: '💊', MDT: '🩺',
    // Energy/Utilities
    XOM: '🛢️', CVX: '⛽', SLB: '🛢️', COP: '🛢️', DUK: '⚡', SO: '⚡', NEE: '🌞', D: '⚡',
    // Industrials/Transport
    F: '🚙', GM: '🚙', UPS: '📦', FDX: '📦', CAT: '🚜', DE: '🚜', GE: '💡', HON: '🏭',
    // Real Estate
    PLD: '🏢', AMT: '📡', SPG: '🏬', PSA: '📦',
    // Communication
    T: '📞', VZ: '📞', CMCSA: '📺', DISH: '📡',
    // Materials
    LIN: '🧪', APD: '⚗️', ECL: '🧴',
    // Berkshire
    BRK: '🦉',
    // ... เพิ่มเติมตามต้องการ
  };

  // แก้ไข symbol ให้เป็นตัวพิมพ์ใหญ่เสมอ
  const key = symbol.toUpperCase();

  // ถ้าเจอใน map ให้คืนอีโมจิ, ถ้าไม่เจอให้คืน default
  return map[key] || '📈';
}